import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { AiKnowledgeStore } from './+state/ai-knowledge.store';
import { AiKnowledgeService } from './service/ai-knowledge.service';

export function provideAiKnowledge(): EnvironmentProviders {
  return makeEnvironmentProviders([AiKnowledgeService, AiKnowledgeStore]);
}
